import { render, staticRenderFns } from "./open-page-layout.vue?vue&type=template&id=7dbe0121&scoped=true&"
import script from "./open-page-layout.vue?vue&type=script&lang=js&"
export * from "./open-page-layout.vue?vue&type=script&lang=js&"
import style0 from "./open-page-layout.vue?vue&type=style&index=0&id=7dbe0121&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbe0121",
  null
  
)

export default component.exports